import React from "react";
import { Card, CardHeader, CardBody } from "../card/card";

const ProgressOverview = ({ quizStructure, currentIndex, onNavigate, isItemComplete }) => {
  const thumb_index = quizStructure.thumb_index;
  const buttonStyle = {
    minWidth: "40px",
    height: "40px",
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  return (
    <Card>
      <CardHeader>
        <h3>Progress Overview</h3>
      </CardHeader>
      <CardBody>
        <div
          className="grid-container"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(40px, 1fr))",
            gap: "8px",
            marginBottom: "16px",
          }}
        >
          {/* Intro Voiceover Button */}
          <button
            key="intro"
            className={`btn btn-sm ${
              quizStructure.introvoice?.voice ? "btn-success" : "btn-outline-secondary"
            } ${currentIndex === 0 ? "active" : ""}`}
            style={{
              ...buttonStyle,
              // Optional: If you want to also highlight the intro if thumb_index is set for it,
              // you could add a condition here.
            }}
            onClick={() => onNavigate(0)}
          >
            Intro
          </button>

          {/* Quiz Items Buttons */}
          {quizStructure.items.map((item, index) => (
            <button
              key={index}
              className={`btn btn-sm ${
                isItemComplete(item) ? "btn-success" : "btn-outline-secondary"
              } ${currentIndex === index + 1 ? "active" : ""}`}
              style={{
                ...buttonStyle,
                border: thumb_index === index ? "2px solid orange" : undefined,
              }}
              onClick={() => onNavigate(index + 1)}
            >
              {index + 1}
            </button>
          ))}
        </div>
      </CardBody>
    </Card>
  );
};

export default ProgressOverview;
